import { Component, OnInit } from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit{

  isLoading$ = this._loadingService.isLoading$;
  constructor(private _loadingService: LoadingService) { }

  ngOnInit(): void {
    
  }

}
